// extracted by mini-css-extract-plugin
export default {"root":"HeaderItem_root__TElFU","title":"HeaderItem_title__TTWNt","editButton":"HeaderItem_editButton__bjDZx"};